import React from "react";
import styles from "./index.module.css";
import { FaRegWindowClose } from "react-icons/fa";

const Notes = ({ notes, onCancel }) => {
  return (
    <div className={styles["transport__data-notes-display"]}>
      <FaRegWindowClose
        className={styles["transport__data-notes-display__close"]}
        size={24}
        color="#a71313"
        onClick={onCancel}
      />
      <label className={styles["transport__data-notes-display-label"]}>
        {"Notes"}
      </label>
      <div className={styles["transport_notes-container"]}>
        <ul className={styles["transport__data-notes-display-notes"]}>
          {notes.split(" >")?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Notes;
